import { Breadcrumbs} from "../../../AbstractElements";
import { Container, Row } from "reactstrap";
import { HeadingCart } from "./HeadingCard";
import ColorCart from "./ColorHeading";
import { FontWeightCart  } from "../Typography/FontWeight/index";
import ListingCard from "./ListingTypography";
import DisplayCart from "./DisplayHeading";
import InlinetextCart from "./InlineText";
import TextColorCart from "./TextColor";
import BlockQuotsCart from "./BlockQuots";



const TypographtContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle="Typography" parent="Ui Kits" title="Typography" />
      <Container fluid>
        <Row>
          <HeadingCart />
          <ColorCart />
          <FontWeightCart/>
          <ListingCard/>
          <DisplayCart />
          <InlinetextCart />
          <TextColorCart />
          <BlockQuotsCart />
        </Row>
      </Container>
    </>
  );
};

export default TypographtContainer;
